import React, { forwardRef, memo, useMemo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import { generateSvgId } from 'src/lib/svg';

export const IconAddInfo = memo(
  forwardRef((props, ref) => {
    const id1 = useMemo(() => generateSvgId(), []);
    const id2 = useMemo(() => generateSvgId(), []);
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 38 38"
        data-fill-none
      >
        <g filter={`url(#${id1})`}>
          <path
            d="M5 15C5 7.26801 11.268 1 19 1C26.732 1 33 7.26801 33 15C33 22.732 26.732 29 19 29H5.54902C5.2458 29 5 28.7542 5 28.451V15Z"
            fill="white"
          />
          <path
            d="M5.5 15C5.5 7.54416 11.5442 1.5 19 1.5C26.4558 1.5 32.5 7.54416 32.5 15C32.5 22.4558 26.4558 28.5 19 28.5H5.54902C5.52195 28.5 5.5 28.4781 5.5 28.451V15Z"
            stroke="currentColor"
          />
          <rect
            x="9"
            y="5"
            width="20"
            height="20"
            rx="10"
            fill="#F0F0F0"
          />
          <g clipPath={`url(#${id2})`}>
            <path
              d="M19 10.5V19.5"
              stroke="#0C5CEF"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.5 15H23.5"
              stroke="#0C5CEF"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <defs>
          <filter
            id={id1}
            x="0"
            y="0"
            width="38"
            height="38"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood
              floodOpacity="0"
              result="BackgroundImageFix"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feMorphology
              radius="2"
              operator="erode"
              in="SourceAlpha"
              result="effect1_dropShadow_1406_672"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite
              in2="hardAlpha"
              operator="out"
            />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_1406_672"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feMorphology
              radius="1"
              operator="erode"
              in="SourceAlpha"
              result="effect2_dropShadow_1406_672"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="3" />
            <feComposite
              in2="hardAlpha"
              operator="out"
            />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_1406_672"
              result="effect2_dropShadow_1406_672"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect2_dropShadow_1406_672"
              result="shape"
            />
          </filter>
          <clipPath id={id2}>
            <rect
              width="12"
              height="12"
              fill="white"
              transform="translate(13 9)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
